
// export const API_URL = 'http://192.168.18.80:3005'
// export const API_URL = 'http://192.168.18.10:3001'
// export const API_URL = 'https://api.safedingo.com'
// export const API_URL = 'http://192.168.18.48:3005'
export const API_URL = 'http://ec2-34-222-238-25.us-west-2.compute.amazonaws.com:4242/'